function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { forwardRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Fade } from 'react-bootstrap';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import { Else, If, Then } from 'react-if';
var Alert = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? Variant.success : _ref$variant,
      additionalClassName = _ref.additionalClassName,
      dismissible = _ref.dismissible,
      _ref$isOpen = _ref.isOpen,
      isOpenFromProps = _ref$isOpen === void 0 ? true : _ref$isOpen,
      onClose = _ref.onClose;

  var _useState = useState(isOpenFromProps),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCloseInProcess = _useState4[0],
      setIsCloseInProcess = _useState4[1];

  var _useState5 = useState(!isOpenFromProps),
      _useState6 = _slicedToArray(_useState5, 2),
      isDisplayNone = _useState6[0],
      setIsDisplayNone = _useState6[1];

  useEffect(function () {
    setIsOpen(isOpenFromProps);
  }, [isOpenFromProps]);

  var handlerClose = function handlerClose() {
    if (!onClose) {
      setIsOpen(false);
      return;
    }

    var res = onClose();

    if (!res) {
      setIsOpen(false);
      return;
    }

    setIsCloseInProcess(true);
    res.then(function () {
      setIsOpen(false);
    })["catch"](function () {
      setIsCloseInProcess(false);
    });
  };

  var renderCloseButton = function renderCloseButton() {
    if (!dismissible) {
      return null;
    }

    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: handlerClose
    }, /*#__PURE__*/React.createElement(If, {
      condition: isCloseInProcess
    }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-spin fa-spinner fs-16"
    })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-times fs-16"
    }))));
  };

  var handlerFadeOnEnter = function handlerFadeOnEnter() {
    setIsDisplayNone(false);
  };

  var handlerFadeOnExited = function handlerFadeOnExited() {
    setIsDisplayNone(true);
  };

  return /*#__PURE__*/React.createElement(Fade, {
    "in": isOpen,
    onEnter: handlerFadeOnEnter,
    onExited: handlerFadeOnExited
  }, /*#__PURE__*/React.createElement("div", {
    ref: forwardedRef,
    className: classNames("alert alert-".concat(variant), _defineProperty({}, additionalClassName, additionalClassName), {
      'alert-dismissible': dismissible
    }, {
      'd-none': isDisplayNone
    })
  }, children, renderCloseButton()));
});
export { Alert };